// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__5x9R3","svgWrapper":"contact_svgWrapper__sda-K","info":"contact_info__Xohbb","mail":"contact_mail__gUFjM","social":"contact_social__WoVWi"};